import { CurrencyValue } from '../../model'
import { Settings } from '../../providers'

export function getFirstValueWithSlippage(
  controlled: 'first' | 'second',
  firstValue: CurrencyValue,
  settings: Settings
): CurrencyValue {
  let firstValueWithSlippage = firstValue
  if (controlled === 'second') {
    firstValueWithSlippage = firstValue.map((x) => x.mul(1000 + settings.slippageTolerance).div(1000))
  }
  return firstValueWithSlippage
}

export function getSecondValueWithSlippage(
  controlled: 'first' | 'second',
  secondValue: CurrencyValue,
  settings: Settings
): CurrencyValue {
  let secondValueWithSlippage = secondValue
  if (controlled === 'first') {
    secondValueWithSlippage = secondValue.map((x) => x.mul(1000 - settings.slippageTolerance).div(1000))
  }
  return secondValueWithSlippage
}
